import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
// import Image from 'react-bootstrap/Image';
import NotificationsAlert from "../../services/NotificationsAlert";
// import { ClienteContext } from "../../services/ClienteContext";
import Conect from "../../../Api/Conect";

import "./RecPass.css";
import Logo from '../../assets/Logo.png'


const RecPass = () => {

    const history = useNavigate();
    const { register, handleSubmit, } = useForm();
    // const cliente = useContext(ClienteContext);
    const [email, setEmail] = useState()

    const onSubmit = async (data) => {
        // const token = localStorage.getItem("token")

        const usuario = await Conect.post(`/recmail`, {
            email: data.email,
        })
        if (usuario.data.erro === true) {
            if (usuario.data.status === true) {
                NotificationsAlert("danger", "Atenção", usuario.data.msg)
            } else {
                NotificationsAlert("warning", "Atenção", usuario.data.msg)
            }
        }
        else {
            NotificationsAlert("default", "Atenção", usuario.data.msg)
            history("/login");
        }
    };

    return (
        <div style={{ width: '100vw', display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div className="container-login">
                <div className="wrap-login">
                    <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
                        <span className="login-form-title"> Recuperar acesso. </span>

                        <span className="login-form-title">
                            <img src={Logo} alt="Sakamotto Server Logo" />
                        </span>
                        <p className="p-rec-pass">Para que seja possivel recuperar seu acesso, informe seu email.</p>

                        <div className="wrap-input">
                            <input
                                className={email !== "" ? "has-val input" : "input"}
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                {...register("email")}
                            />
                            <span className="focus-input" data-placeholder="Email"></span>
                        </div>

                        <div className="container-login-form-btn">
                            <button className="login-form-btn">Recuperar</button>
                            <span className="txt1">Ja tem cadastro?</span>
                            <button
                                className="txt2"
                                onClick={() => {
                                    history("/login");
                                }}
                                style={{ background: "none", border: "none", color: "blue", textDecoration: "underline", cursor: "pointer" }}
                            >
                                Logar!
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )

}

export default RecPass;
